import './contact.scss';

class Contact {
    constructor ($contactModule) {
        this.$contactModule = $contactModule;
        this.init();
    }

    init () {
        this.bindEvents();
        this.checkAnchor();
    }

    bindEvents () {
        const $$mapButtons = this.$contactModule.querySelectorAll('[data-contact="open-map"]');

        if ($$mapButtons.length > 0) {
            $$mapButtons.forEach($mapButton => {
                $mapButton.addEventListener('click', () => {
                    this.$contactModule.classList.add('contact--map-active');
                });
            });
        }

        const $$contactButtons = this.$contactModule.querySelectorAll('[data-contact="open-form"]');

        if ($$contactButtons.length > 0) {
            $$contactButtons.forEach($contactButton => {
                $contactButton.addEventListener('click', () => {
                    this.$contactModule.classList.remove('contact--map-active');
                });
            });
        }
    }

    checkAnchor () {
        const hash = window.location.hash;
        let hashId;

        if (hash !== '') {
            hashId = hash.split('#')[1];

            if (hashId === 'map') {
                this.$contactModule.classList.add('contact--map-active');
            }

            if (hashId === 'form') {
                this.$contactModule.classList.remove('contact--map-active');
            }
        }
    }
}

export { Contact };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$contact = $context.querySelectorAll('[data-contact="root"]');
        for (let i = 0; i < $$contact.length; i++) {
            const $contact = $$contact[i];
            $contact.API = new Contact($contact);
        }
    }
});
